import { productsFlat, WeatherProduct } from '../products/products';

export class WeatherAltitudeSelector {
    private productGrouped = Object.groupBy(
        productsFlat.filter((x) => x.group !== null && x.altitude !== null),
        (x) => x.group!
    );

    constructor() {
        for (const group of Object.values(this.productGrouped)) {
            group?.sort((a, b) => a.altitude! - b.altitude!);
        }
    }

    private altitude: number = 0;

    setAltitude(value: number) {
        this.altitude = value;
    }

    getAltitude() {
        return this.altitude;
    }

    pick(groupId: number): WeatherProduct | null {
        const products = this.productGrouped[groupId] ?? [];
        return products.findLast((x) => x.altitude! <= this.altitude) ?? null;
    }
}
